import * as yup from 'yup';

/**
 * Reusable schema for line item validation
 * Used by both matched and unmatched line items
 */
const lineItemSchema = yup.object().shape({
  mismatch: yup.boolean().optional(),
  item: yup.object().shape({
    prices: yup.object().shape({
      mismatch: yup.boolean().optional(),
      consolidated_unit_price: yup
        .object()
        .nullable()
        .optional()
        .when('mismatch', (values, schema) => {
          const mismatch = values[0];
          return mismatch === true
            ? schema.shape({
                actual: yup.number().test('always-error', 'This field has an error', () => false),
              })
            : schema.optional();
        }),
    }),
    taxes: yup.object().shape({
      mismatch: yup.boolean().optional(),
      actual: yup
        .object()
        .nullable()
        .optional()
        .when('mismatch', (values, schema) => {
          const mismatch = values[0];
          return mismatch === true
            ? schema.shape({
                percentage: yup.number().test('always-error', 'This field has an error', () => false),
              })
            : schema.optional();
        }),
    }),
  }),
  quantities: yup.object().shape({
    invoiced_quantity: yup
      .object()
      .nullable()
      .optional()
      .when('mismatch', (values, schema) => {
        const mismatch = values[0];
        return mismatch === true
          ? schema.shape({
              value: yup
                .number()
                .nullable()
                .optional()
                .test('always-error', 'This field has an error', () => false),
            })
          : schema.optional();
      }),
  }),
});

/**
 * Yup validation schema for invoice verification details
 * Defines validation rules for line items, charges, and related fields
 */
export const invoiceVerificationDetailsSchema = yup.object().shape({
  matched_line_items: yup.array().of(lineItemSchema),
  unmatched_line_items: yup.array().of(lineItemSchema),
  charges: yup.array().of(
    yup
      .object()
      .shape({
        mismatch: yup.boolean().optional(),
      })
      .test('mismatch-error', 'This charge has an error', function (value) {
        return value?.mismatch !== true;
      }),
  ),
  allowances: yup.array().of(
    yup
      .object()
      .shape({
        mismatch: yup.boolean().optional(),
      })
      .test('mismatch-error', 'This allowance has an error', function (value) {
        return value?.mismatch !== true;
      }),
  ),
});
